export const TOURNAMENT_FIELD_ORDER = [
  'name', 'organizerName', 'city', 'ground', 'organizerNumber',
  'tournamentStartDate', 'tournamentEndDate', 'registrationEndDate',
  'tournamentBanner', 'tournamentLogo',
];

export const validateTournamentForm = (form = {}) => {
  const errors = {};
  if (!String(form.name || '').trim()) errors.name = 'Enter the tournament name.';
  if (!String(form.organizerName || '').trim()) errors.organizerName = 'Enter the organizer name.';
  if (!String(form.city || '').trim()) errors.city = 'Enter the tournament city.';
  if (!String(form.ground || '').trim()) errors.ground = 'Enter the ground or venue.';
  const phone = String(form.organizerNumber || '').replace(/\D/g, '');
  if (!phone) errors.organizerNumber = 'Enter the organizer mobile number.';
  else if (phone.length !== 10) errors.organizerNumber = 'Enter a 10-digit mobile number.';
  if (!form.tournamentStartDate) errors.tournamentStartDate = 'Choose the tournament start date.';
  if (!form.tournamentEndDate) errors.tournamentEndDate = 'Choose the tournament end date.';
  const start = form.tournamentStartDate ? new Date(form.tournamentStartDate) : null;
  const end = form.tournamentEndDate ? new Date(form.tournamentEndDate) : null;
  const registration = form.registrationEndDate ? new Date(form.registrationEndDate) : null;
  if (start && end && end < start) errors.tournamentEndDate = 'End date must be on or after the start date.';
  if (registration && start && registration > start) errors.registrationEndDate = 'Registration end date must be on or before the tournament start date.';
  return errors;
};

export const normalizeFormError = (error, { imageField } = {}) => {
  const status = Number(error?.status || 0);
  const raw = String(error?.message || '');
  const data = error?.data || error?.payload || {};
  if (status === 413 || /payload too large|http 413/i.test(raw)) return { field: imageField || 'tournamentBanner', message: 'The selected image is too large to upload. Choose a smaller image or try another photo.' };
  if (/failed to fetch|network error|network request failed/i.test(raw)) return { field: null, message: "Couldn't connect to CrickArena. Check your internet connection and try again." };
  if (status >= 500 || /http 5\d\d|internal server/i.test(raw)) return { field: null, message: "We couldn't save the tournament right now. Your information is still here. Try again." };
  const message = raw || 'Unable to save the tournament. Review the highlighted fields and try again.';
  const mappings = [[/tournament name/i, 'name'], [/start date/i, 'tournamentStartDate'], [/registration end date/i, 'registrationEndDate'], [/end date/i, 'tournamentEndDate'], [/banner/i, 'tournamentBanner'], [/logo/i, 'tournamentLogo']];
  return { field: error?.field || data.field || data.details?.field || mappings.find(([pattern]) => pattern.test(message))?.[1] || null, message };
};

export const focusFirstError = (errors = {}, refs = {}) => {
  const field = TOURNAMENT_FIELD_ORDER.find((key) => errors[key]);
  const node = field ? refs[field]?.current : null;
  node?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
  node?.focus?.({ preventScroll: true });
  return field || null;
};
